import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

import { ENDPOINTS, URLS } from '@shared/constants';
import { SaasRequestDTO } from '@shared/dtos';
import { CommonResponseDTO, ISaasConfig } from '@shared/interfaces';
import { generateURL } from '@shared/utils';

type SaaSSetupResponse = CommonResponseDTO<ISaasConfig>;

@Injectable({
  providedIn: 'root',
})
export class SaaSSetupDataService {
  public dataStore = new BehaviorSubject<ISaasConfig | undefined>(undefined);

  constructor(private http: HttpClient) {}

  loadSystemData(): Observable<SaaSSetupResponse> {
    return this.http.get<SaaSSetupResponse>(URLS.SYSTEM_DATA_SAAS).pipe(
      tap(({ data }) => {
        this.dataStore.next(data);
      })
    );
  }

  updateSystemData(system: SaasRequestDTO): Observable<SaaSSetupResponse> {
    const body: SaasRequestDTO = {
      ...system,
    };
    return this.http.patch<SaaSSetupResponse>(URLS.SYSTEM_DATA_SAAS, body).pipe(
      tap((res) => {
        this.dataStore.next(res.data);
      })
    );
  }

  updateAdminConfig(body: Partial<ISaasConfig>): Observable<SaaSSetupResponse> {
    const url = generateURL({ endpoint: ENDPOINTS.SAAS_ADMIN_SETUP });
    console.log({ url });
    return this.http.patch<SaaSSetupResponse>(url, body).pipe(
      tap(({ data }) => {
        this.dataStore.next(data);
      })
    );
  }
}
